<template>
  <q-route-tab
    v-bind="objectBindings"
    @click="onClick"
  >
    {{ translatedLabel }}
  </q-route-tab>
</template>
<script>
import Permissions from '@/classes/Permission'

export default {
  props: {
    bindings: {
      type: Object
    },
    label: {
      type: String
    },
    auth: {}
  },
  data() {
    return {
      unauthorizedBindings: {
        "to": "",
        "disable": true
      },
      unauthorizedTalentBindings: {
        "to": "",
        "hidden": true
      }
    }
  },
  computed: {
    authorized() {
      if (this.auth) {
        return Permissions.planCan(this.auth)
      }
      return true
    },
    planIsTalent() {
      return this.$store.getters.getCurrentPlanIsTalent
    },
    objectBindings() {
      if (!this.authorized) {
        if (this.planIsTalent) {
          return this.unauthorizedTalentBindings
        }
        return this.unauthorizedBindings
      }
      return this.bindings
    },
    translatedLabel() {
      return this.$t(`ui.menu.${this.label}`)
    }
  },
  methods: {
    onClick() {
      if (!this.authorized) {
        this.$store.commit('SET_NOT_ALLOWED_MODAL_SHOWN', true)
        this.$emit('close', true)
      }
    }
  },
}
</script>
<style lang="sass" scoped>

.q-tab
  text-transform: none
  font-weight: $font-medium
  font-size: .95em
  min-height: 70px
  padding: 0 20px
  color: $ink-lighter
  cursor: pointer
  transition: all .15s ease-out
  background: transparent
  &:hover
    color: $paper-lighter
    &:before
      background: $ink-dark
  &:active
    color: $paper-lighter


.q-router-link-active
  background: transparent
  color: $paper-light


.disabled
  background-color: transparent
</style>



// WEBPACK FOOTER //
// AuthenticatedNavigationItem.vue?5c28c735